import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ExtrasService } from '../../../services';
import { QuoteToolLiteStore } from '../../../store';
import { Accommodation, ExtrasSummary, PremiumActivities } from '../../../types';
import { AccommodationsTypeComponent } from '../../accommodations-type/accommodations-type.component';
import { PremiumAccommodationComponent } from '../../premium-accommodation/premium-accommodation.component';
import { PremiumActivitiesComponent } from '../../premium-activities/premium-activities.component';
import { PremiumResidence } from '@lx/shared/data-access/products';
import { Flow } from '@lx/quote-tool/lite/shared/types';

@Component({
  standalone: true,
  imports: [AccommodationsTypeComponent, PremiumAccommodationComponent, PremiumActivitiesComponent, CommonModule, AsyncPipe],
  selector: 'lx-extras-step',
  templateUrl: './extras-step.component.html',
  styleUrls: ['./extras-step.component.scss'],
})
export class ExtrasStepComponent implements OnInit {
  protected activeFlow$: Observable<Flow> | undefined;
  protected accommodations: Accommodation[] = [];
  protected accommodationOptional = true;
  protected premiumActivities: PremiumActivities | undefined;
  protected premiumAccommodation: PremiumResidence | undefined;

  private readonly quoteToolLiteStore = inject(QuoteToolLiteStore);
  private readonly extrasService = inject(ExtrasService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.activeFlow$ = this.quoteToolLiteStore.activeFlow$;
    this.quoteToolLiteStore.selectionForExtraSummary$
      .pipe(
        switchMap(({ activeFlow, selectedSchoolLocation, selectedStartDate, selectedProductPackage }) =>
          this.extrasService.findExtrasSummary(activeFlow, selectedSchoolLocation?.schoolCode, selectedStartDate, selectedProductPackage),
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((extras: ExtrasSummary) => {
        this.premiumActivities = extras?.premiumActivities;
        this.premiumAccommodation = extras?.premiumResidences;
        this.accommodations = extras?.accommodations ?? [];
        this.accommodationOptional = extras?.accommodationOptional;

        // Once the extras are loaded, we can update the validity of the current step
        this.quoteToolLiteStore.updateValidityOfCurrentStep(true);
      });
  }
}
